import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import {
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import moment from 'moment';
import SearchButton from '../../components/atoms/SearchButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { sendLogin } from '../../auth/Auth';
import {
  getDonateHistoryGochiKid,
  GET_DONATE_HISTORY_GOCHI_KID_SUCCESS
} from '../../actions/Options';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0px',
    minWidth: 1024
  },
  searchForm: {
    padding: '10px 26px 10px 26px',
    marginLeft: '-5px',
    marginRight: '-5px'
  },
  rowForm: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    width: '20%'
  },
  textField: {
    position: 'relative'
  },
  tableContainer: {
    position: 'relative',
    marginTop: 15,
    backgroundColor: '#FFFFFF'
  },
  toolbar: {
    display: 'flex',
    fontSize: 24,
    fontWeight: 'bold'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)',
    minWidth: 1024
  },
  buttonSearch: {
    margin: '22px 0 22px 10px',
    height: 38
  },
  tableCell: {
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getDonateHistoryGochiKid
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('page', 'setPage', 1),
  withState('listDonate', 'setListDonate', []),
  withState('donateAtFrom', 'setDonateAtFrom', null),
  withState('donateAtTo', 'setDonateAtTo', null),
  withState('countDonate', 'setCountDonate', 0),
  withState('limitDonate', 'setLimitDonate', 20),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => event => {
      props.setLimitDonate(event.target.value);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 20;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        donateAtFrom: props.donateAtFrom,
        donateAtTo: props.donateAtTo,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getDonateHistoryGochiKid(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }

          if (data.type === GET_DONATE_HISTORY_GOCHI_KID_SUCCESS) {
            props.setCountDonate(data.payload.count);
            props.setListDonate(data.payload.list);
            props.setLimitDonate(data.payload.limit);
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
          } else {
            props.setCountDonate(0);
            props.setListDonate([]);
            props.setResultMessage('エラーが発生しました！');
            props.updateLoading(false);
            props.updateOpenTable(false);
          }
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.handleChangePage(null, 1, this.props.limitDonate);
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    handleChangeRowsPerPage,
    openTable,
    updateOpenTable,
    loading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    donateAtFrom,
    setDonateAtFrom,
    donateAtTo,
    setDonateAtTo,
    page,
    countDonate,
    listDonate,
    limitDonate,
    setLimitDonate
  }) => {
    // setResultMessage,
    // page,
    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 20;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };
    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="入金情報管理" />
        <main className={classes.content}>
          <div className={classes.toolbar}>こどもごちめし支援額詳細</div>
          <Paper className={classes.mainPaper} elevation={1}>
            <div className={classes.searchForm}>
              <div className={classes.rowForm}>
                <FormControl
                  className={[classes.margin, classes.formControl]}
                  variant="outlined"
                  size="small"
                >
                  <TextField
                    label="支援日時(From)"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={donateAtFrom}
                    onChange={e => {
                      setDonateAtFrom(e.target.value);
                    }}
                    onBlur={e => {
                      if (!donateAtFrom) {
                        e.target.value = '';
                        setDonateAtFrom('');
                      }
                    }}
                  />
                </FormControl>
                <FormControl
                  className={[classes.margin, classes.formControl]}
                  variant="outlined"
                  size="small"
                >
                  <TextField
                    label="支援日時(To)"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={donateAtTo}
                    onChange={e => {
                      setDonateAtTo(e.target.value);
                    }}
                    onBlur={e => {
                      if (!donateAtTo) {
                        e.target.value = '';
                        setDonateAtTo('');
                      }
                    }}
                  />
                </FormControl>
              </div>

              <SearchButton
                customStyles={classes.buttonSearch}
                onClickAction={searchAction}
              />
            </div>
          </Paper>

          {openTable && (
            <div className={classes.tableContainer}>
              <div className={classes.scrollTable} id="scrollTableId">
                <Table stickyHeader>
                  <TableHead>
                    <TableRow className={classes.headerRow}>
                      <TableCell>支援日時</TableCell>
                      <TableCell>支援額</TableCell>
                      <TableCell>こども達へのメッセージ</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listDonate &&
                      listDonate.map(item => (
                        <TableRow>
                          <TableCell>
                            {moment(item.donateAt).format('YYYY-MM-DD')}
                            <br />
                            {moment(item.donateAt).format('THH:mm:ss')}
                          </TableCell>
                          <TableCell>
                            {item.donateAmount
                              ? item.donateAmount.toLocaleString()
                              : 0}
                            円
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {item.donateMessage}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
              <div>
                <ExPaginationGroup
                  count={
                    countDonate % limitDonate > 0
                      ? Math.floor(countDonate / limitDonate) + 1
                      : Math.floor(countDonate / limitDonate)
                  }
                  selectedPage={page}
                  handleChangePage={(e, p, l) => handleChangePage(e, p, l)}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  limit={limitDonate}
                  totalCount={countDonate}
                  setLimit={setLimitDonate}
                />
              </div>
            </div>
          )}
        </main>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
